import { render, staticRenderFns } from "./program@.vue?vue&type=template&id=75cf7f3a&scoped=true&"
import script from "./program@.vue?vue&type=script&lang=ts&"
export * from "./program@.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75cf7f3a",
  null
  
)

export default component.exports